import React, { memo, useEffect } from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import styled from "styled-components";
import { AppLanguage, uiActions } from './redux';
import RecoveryScreen from "./screens/RecoveryScreen"
import HomeScreen from "./screens/HomeScreen";
import Cookies from 'universal-cookie';
import QrLoginScreen from './screens/QrLoginScreen';
import RegistrationScreen from './screens/RegistrationScreen';
import { Modal } from './components';
import RegisterCompany from './screens/RegisterCompany';
//import OpenBankingScreen from "./screens/OpenBankingScreen";

const StyledApp = styled.div`
	width: 100%;
	height: 100%;
`;


export function App({ t, i18n, tReady }: WithTranslation) {
	const cookies = new Cookies();
	const dispatch = useDispatch();

	useEffect(() => {
		const language = cookies.get("i18next");
		switch (language) {
			case "en":
				dispatch(uiActions.setApplicationLanguage(AppLanguage.EN));
				break;
			case "hu":
				dispatch(uiActions.setApplicationLanguage(AppLanguage.HU));
				break;
			case "lv":
				dispatch(uiActions.setApplicationLanguage(AppLanguage.LV));
				break;
			default:
				dispatch(uiActions.setApplicationLanguage(AppLanguage.EN));
		}
	},[])

	return (
		<StyledApp>
			<Switch>
				<Route path="/" exact render={() => <HomeScreen />} />
				<Route path="/recovery" exact render={() => <RecoveryScreen />} />
				<Route path="/qrLogin" exact render={() => <QrLoginScreen />}/>
				<Route path="/registration" exact render={(props) => {
					const urlParams = new URLSearchParams(props.location.search);
					const companyId = urlParams.get("company");
					return companyId ? <RegisterCompany /> : <RegistrationScreen />;
				}}/>
				{/*<Route path="/openBanking" exact render={() => <OpenBankingScreen />} />*/}
				<Redirect to="/" />
			</Switch>
			<Modal t={t} i18n={i18n} tReady={tReady} />
		</StyledApp>
	);
}

export default withTranslation()(memo(App));

